import React from "react"
import Link from "gatsby-link"
import helloworld from '../images/helloworld.jpg'

const imageWrapperStyle = {
  display: 'inline-block',
}

const containerStyle = {
  margin: '0%',
  display: 'inline-block',
};

const headerImgStyle = {
  borderRadius: '50%',
  position: 'inline',
  width: '150px',
  marginTop: '11px',
  filter: 'saturate(50%)',
};

const circleStyle = {
  position: 'relative',
  width: '100%',
  margin: '0 auto',
};

const circleTextStyle = {
  fontFamily: 'Courier, monospaced',
  fontSize: '16px',
  fill: '#605980',
}

const circleSvgStyle = {
  position: 'absolute',
  left: '0',
  top: '0',
  width: '100%',
  overflow: 'visible',
}

export default () =>
  <div className="imageWrapper"> 
    <div id="header-image-container" style={containerStyle}>
      <div id="circle" style={circleStyle}>
        <svg style={circleSvgStyle}
          className="lead-circle-svg"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
          x="0px" y="0px" width="170px" height="170px" viewBox="0 0 320 320" enable-background="new 0 0 300 300" xmlSpace="preserve">
          <defs>
            <path id="circlePath" d=" M 160, 160 m -160, 0 a 160,160 0 0,1 320,0 a 160,160 0 0,1 -320,0 " />
          </defs>
          <g>
            <use xlinkHref="#circlePath" fill="rgba(50, 50, 50, 0.0)" />
            <text style={circleTextStyle}>
              <textPath xlinkHref="#circlePath">"Your friend online"</textPath>
            </text>
          </g>
        </svg>
        <Link to='/about'>
          <img id="center-img"
            className="lead-circle-img"
            src={helloworld}
            style={headerImgStyle}
            alt="Shane Cummerford"
          />
        </Link>
      </div>
    </div>
  </div>


// WEBPACK FOOTER //
// ./src/components/headerImage.js